import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import users from '../modules/users/store';
import planning from '../modules/planning/store';
import profile from '../modules/profile/store';
import calendar from '../modules/calendar/store';
import core from '../modules/core/store';
import auth from '../common/auth/store';
import userActions from '../modules/users/actions/store';
import roles from '../modules/roles/store';
import adapters from '../modules/adapters/store';
import locales from '../common/locales/store';
import lifecycle from '../common/lifecycle/store';
import setup from '../modules/setup/store';
import solution from '../modules/solution/store';
import notification from '../common/notification/store';
import version from '../common/version/store';
import dutyExchange from '../modules/dutyexchange/store';
import qualification from '../modules/qualification/store';
import apikey from '../modules/apiKey/store';
import plugin from '../modules/plugin/store';
import extraPay from '../modules/extraPay/store';
import statisticsOverview from '../modules/statisticsOverview/store';
import worktimeSummary from '../modules/worktimeSummary/store';
import userGroup from '../modules/userGroup/store';
import dutyTemplates from '../modules/dutyTemplates/store';
import report from '../modules/report/store';
import webPush from '../common/web-push/store';
import violation from '../modules/violation/store';
import userScores from '../modules/userScores/store';
import absenceStatistics from '../modules/absenceStatistics/store';
import days from '../common/days/store';
import basicFitness from '../modules/basicFitness/store';
import performanceMetrics from '../modules/performanceMetrics/store';
import pluginStores from '../../plugins/common/frontend/store';

const state = {};
const getters = {};
const mutations = {};

const actions = {
	async load({ state, commit, rootState, dispatch }, { tenant, locale }) {
		dispatch('lifecycle/init');

		await dispatch('profile/load', { browserLocale: locale, tenant });

		//Check if locales is not empty
		if (rootState.locales.list.length === 0) {
			await dispatch('locales/getLocales');
		}

		dispatch('lifecycle/setLoading', false);

		//All actions within this if-statement are called only upon the initial load of the application when the user is already logged in. Not after logging in!
		if (rootState.auth.user) {
			dispatch('notification/getNotifications');
			dispatch('plugin/load');
		}
	},
};

const modules = {
	users,
	planning,
	profile,
	calendar,
	core,
	auth,
	userActions,
	roles,
	adapters,
	locales,
	lifecycle,
	setup,
	solution,
	notification,
	version,
	dutyExchange,
	qualification,
	plugin,
	extraPay,
	statisticsOverview,
	apikey,
	worktimeSummary,
	userGroup,
	dutyTemplates,
	report,
	webPush,
	violation,
	userScores,
	absenceStatistics,
	days,
	basicFitness,
	performanceMetrics,
	...pluginStores,
};

export default createStore({
	plugins: [
		createPersistedState({
			storage: window.sessionStorage,
			paths: [
				'auth/error',
				'auth/message',
				'auth/resetToken',
				'auth/selectedTenant',
				'auth/signupAllowed',
				'auth/status',
				'auth/tenants',
				'setup/setup',
				'locales',
			],
		}),
	],
	// 4. Update the environment variable check for Vite
	strict: !import.meta.env.PROD,
	state,
	getters,
	mutations,
	actions,
	modules,
});
